module.exports = __webpack_public_path__ + "img/edu-road-1.eafae956.png";